var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.5848 0 0 3.5848 0 8C0 12.4152 3.5848 16 8 16C12.4152 16 16 12.4152 16 8C16 3.5848 12.4152 0 8 0ZM6.868 8L4.6056 5.7368C4.2936 5.4248 4.2936 4.9176 4.6056 4.6056C4.9176 4.2936 5.4248 4.2936 5.7368 4.6056L8 6.8688L10.2624 4.6056C10.5744 4.2936 11.0816 4.2936 11.3936 4.6056C11.7064 4.9176 11.7064 5.4248 11.3936 5.7368L9.1312 8L11.3936 10.2624C11.7064 10.5744 11.7064 11.0816 11.3936 11.3936C11.0816 11.7064 10.5744 11.7064 10.2624 11.3936L8 9.1312L5.7368 11.3936C5.4248 11.7064 4.9176 11.7064 4.6056 11.3936C4.2936 11.0816 4.2936 10.5744 4.6056 10.2624L6.868 8Z",
    fill: "#1A1F36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.cce3f4086242246d6404e9d4a9910d15.svg";
export { ForwardRef as ReactComponent };